import * as swcHelpers from '@swc/helpers';
import { parseHtml } from '@grandvisionhq/lib-utils-html';

/**
 * Merges labels as received from the call to Bloomreach into a flat 1 level deep object,
 * and prefixes each label key with the key of the parent object (e.g. carts or stores)
 */ const mergeLabels = (labels)=>{
    return Object.keys(labels).reduce((merged, key)=>{
        const labelGroup = labels[key];
        if (!labelGroup) return merged;
        return swcHelpers.objectSpread({}, merged, Object.entries(labelGroup).reduce((innerLabels, [labelKey, label])=>swcHelpers.objectSpread({}, innerLabels, {
                [`${key}.${labelKey}`]: label
            })
        , {}));
    }, {});
};
const hasLabel = (labels, key)=>!!labels[key]
;
const isDebugEnabled = function() {
    try {
        return !!localStorage.getItem('gv:debug:intl');
    } catch (error) {
        return false;
    }
}();
const getLabel = (labels, key, optionsConfig = {})=>{
    const { defaultValue , hideLabelKey =false  } = optionsConfig;
    if (isDebugEnabled) {
        return `[${key}]`;
    }
    const labelValue = labels[key] || defaultValue;
    if (!labelValue) {
        if (hideLabelKey) {
            return '';
        }
        console.warn(`No translation found for key: [${key}]`);
        return `[${key}]`;
    }
    return labelValue;
};
var getFormattedLabel = (labels, key, optionsConfig = {}, event)=>{
    const { parseLink: parseLinkEnabled , parseHTML , labelData , openLinksInNewTab  } = optionsConfig, getLabelOptions = swcHelpers.objectWithoutProperties(optionsConfig, [
        "parseLink",
        "parseHTML",
        "labelData",
        "openLinksInNewTab"
    ]);
    let label = getLabel(labels, key, getLabelOptions);
    if (isDebugEnabled) {
        return label;
    }
    if (labelData) {
        label = replaceVars(label, labelData);
    }
    if (parseLinkEnabled) {
        label = parseLink(label, openLinksInNewTab);
    }
    /*
    by default parses if parseLinkEnabled,
    unless parseHTML explicitly set to false
  */ if (parseHTML || parseLinkEnabled && parseHTML !== false) {
        if (event) {
            label = parseHtml(label, undefined, ()=>{
                const tealiumEvent = globalThis.dispatchEvent(new CustomEvent('gv:onTealiumEvent', {
                    detail: swcHelpers.objectSpread({}, event, {
                        id: 'Click'
                    })
                }));
                if (!tealiumEvent) {
                    console.error('[Tealium] [HTML] [Link] Error dispatching click event:', event);
                }
            });
        } else {
            label = parseHtml(label);
        }
    }
    return label;
};
const replaceVars = (label, data)=>{
    Object.keys(data).forEach((key)=>{
        const labelGroup = data[key];
        if (!labelGroup) return;
        label = label.replace(`{${key}}`, labelGroup.toString());
    });
    return label;
};
// Parses MarkDown style links to HTML string
// [I'm an inline-style link with title](https://www.google.com "Google's Homepage")
const parseLink = (label, openInNewTab = false)=>{
    const regex = /[\[]{1}([^\]\[]+)[\]]{1}[(]{1}([^()"]+)("(.+)")?[)]{1}/g;
    return label.replace(regex, openInNewTab ? '<a href="$2" title="$4" target="_blank" rel="noopener">$1</a>' : '<a href="$2" title="$4">$1</a>');
};

export { getFormattedLabel, getLabel, hasLabel, mergeLabels, parseLink, replaceVars };
//# sourceMappingURL=helpers.js.map
